"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = invokeAppByIframe;

var _createSchemeCallback = _interopRequireDefault(require("../createSchemeCallback"));

/**
 * @file invokeAppByIframe.js
 * @author zhangyanting
 */

/**
 * 通过iframe调用端能力
 * @param {string} scheme 调起的scheme
 * @param {function} callbackFn 真正回调的函数
 * @param {boolean} isNoDeleteFn 是否删除全局函数
 */
function invokeAppByIframe(scheme, callback, isNoDeleteFn) {
  var schemeTemp = scheme;

  if (Object.prototype.toString.call(callback) === '[object Function]' && scheme.indexOf('callback') === -1) {
    schemeTemp += "".concat(schemeTemp.indexOf('?') > -1 ? '&' : '?', "callback=").concat((0, _createSchemeCallback.default)(callback, isNoDeleteFn));
  }

  var ifr = document.createElement('iframe');
  ifr.src = schemeTemp;
  ifr.style.display = 'none';
  document.head.appendChild(ifr);
  setTimeout(function () {
    document.head.removeChild(ifr);
    ifr = null;
  }, 0);
}